export enum SiteSection {
  captureAdmin = 'capture-admin',
  cePortal = 'ce-portal',
  partnerPortal = 'partner-portal',
  llmPlayground = 'llm-playground',
}
